import { render, staticRenderFns } from "./MenuSelect.vue?vue&type=template&id=d88dfaf0&scoped=true&"
import script from "./MenuSelect.vue?vue&type=script&lang=js&"
export * from "./MenuSelect.vue?vue&type=script&lang=js&"
import style0 from "./MenuSelect.vue?vue&type=style&index=0&id=d88dfaf0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88dfaf0",
  null
  
)

export default component.exports